// Generated by ts-to-zod
import { z } from 'zod';
import { idSchema } from '../../utils/codecUtils.schema';
import { triggerEventTypeSchema } from '../models/trigger.schema';

export const triggersListQuerySchema = z
  .object({
    id: idSchema,
    queue: idSchema,
    event: triggerEventTypeSchema,
  })
  .partial();
